const handleGraphQLErrors = (graphQLErrors) => {
  const error = graphQLErrors[0];
  const { extensions = {} } = error;
  handleError(extensions.httpStatusCode, extensions.apiErrorCode);
}

const handleNetworkError = (networkError) => {
  const { result, statusCode = 404 } = networkError;
  const { error = {} } = result || {};
  handleError(statusCode, error.apiErrorCode);
}

const handleHttpError = (status, error = {}) => {
  handleError(status, error.apiErrorCode);
}

const handleError = (httpStatusCode, apiErrorCode) => {
  if (!httpStatusCode) {
    return;
  }
  switch (httpStatusCode) {
    case 401:
      localStorage.clear();
      window.location.pathname = "/noAccess";
      break;
    case 403:
      if (apiErrorCode === "APP ASA ACCESS ERROR") {
        window.location.pathname = "/asaError";
      } else if (apiErrorCode === "APP PERF TESTING ERROR") {
        window.location.pathname = "/noAccessPerfTesting";
      } else if (apiErrorCode === "APP ACCESS DENIED") {
        window.location.pathname = "/noAccess";
      }
      break;
    case 404:
      window.location.pathname = "/notFound";
      break;
    case 503:
      window.location.pathname = "/maintenance";
      break;
    default:
      break;
  }
}

export {
  handleGraphQLErrors,
  handleNetworkError,
  handleHttpError,
}